import Cytoscape from 'cytoscape'
import nodeHtmlLabel from 'cytoscape-node-html-label'
import panzoom from 'cytoscape-panzoom'
import dagree from 'cytoscape-dagre'

Cytoscape.use(dagree)
nodeHtmlLabel(Cytoscape)
panzoom(Cytoscape)

export default function buildGraph(container, nodes, edges) {
  const cy = Cytoscape({
    container,
    elements: {
      nodes,
      edges,
    },
    layout: {
      name: 'dagre',
      fit: false,
      animate: false,
      nodeSep: 100,
      edgeSep: 150,
      rankSep: 200,
      padding: 50,
      rankDir: 'LR',
      nodeDimensionsIncludeLabels: true,
    },
    style: [
      {
        selector: 'node',
        style: {
          'background-color': 'white',
          'overlay-color': '#3279be',
          shape: 'round-rectangle',
          width: 200,
          height: 46,
        },
      },
      {
        selector: ':selected',
        style: {
          'z-index': 2,
          'background-color': '#3279be',
          'overlay-opacity': 0,
        },
      },
      {
        selector: 'edge',
        style: {
          width: 1.5,
          'overlay-opacity': 0,
          'line-style': 'solid',
          'curve-style': 'bezier',
          'line-color': '#a5bad0',
          'target-arrow-color': '#a5bad0',
          'target-arrow-shape': 'triangle-backcurve',
        },
      },
      {
        selector: 'edge[label]',
        css: {
          label: 'data(relation)',
          color: '#3279be',
          'text-rotation': 'autorotate',
          'text-margin-x': '0px',
          'text-margin-y': '-15px',
          'text-background-color': 'white',
          'text-background-opacity': 1,
          'text-background-shape': 'roundrectangle',
          'text-border-color': 'white',
          'text-border-opacity': 1,
          'text-border-width': 1,
          'text-wrap': 'ellipsis',
          'text-max-width': 150,
        },
      },
    ],
  })

  cy.panzoom({
    minZoom: 0.5,
  })

  return cy
}
